import { render, staticRenderFns } from "./TextCheckbox.vue?vue&type=template&id=0388d617&scoped=true&"
import script from "./TextCheckbox.vue?vue&type=script&lang=ts&"
export * from "./TextCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./TextCheckbox.vue?vue&type=style&index=0&id=0388d617&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388d617",
  null
  
)

export default component.exports